import React, { useState } from "react";
import ComponenetHeader from "../common/ComponenetHeader";
import EmailService from "../../service/EmailService";
import { Alert, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";

const ContactUs =()=>{
    const [formData, setFormData] = useState({name: '', email: '', phone: '', formMessage:'' });
    const [message, setMessage] = useState({ text: '', variant: '' });
    const [loading, setLoading] = useState(false);

    const handleChange =(e) =>{
      const {name, value} = e.target;
      setFormData({ ...formData, [name]: value});
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true); // Set loading to true when the request starts
      setMessage({ text: '', variant: '' }); // Clear previous messages

      try {
         const response = await EmailService.sendEmail(formData);
         setMessage({ text: [response], variant: 'success' });
         setFormData({ name: '', email: '', phone: '', formMessage:'' });
      } catch (error) {
         setMessage({ text: `Error: ${error.message}`, variant: 'danger' });
      } finally {
         setLoading(false);
       }
    }
    return(<>

        <Helmet>
            <link rel="canonical" href="/contact" />
            <title>Contact Us | Breakdowninc | Truck Repair and Truck Parts Shops</title>
            <meta name="keywords" content="Breakdowninc,Contact  Truck Service,Find Truck Service Help,Truck Service Contact,Truck Contact,Service Contact,Find Service Contact,Truck Parts Contact"/>
            <meta name="description" content="Breakdowninc will answer all your questions and how we can help you with our Breakdown Directory."/>
            <meta property="og:title" content="Contact Us | Breakdowninc | Truck Repair and Truck Parts Shops"/>
            <meta property="og:description" content="Breakdowninc will answer all your questions and how we can help you with our Breakdown Directory."/>
        </Helmet>

        <ComponenetHeader
           name={'Contact Us'}
        />

      <section className="contactPage_section">
        <div className="container">
           <div className="row justify-content-center">
              <div className="col-md-12">
                 <div className="contact_title">
                   <h1>Get In Touch With <br/>Breakdown Inc</h1>
                   <h4 className="mb-md-3 mb-1">For 24/7 support and inquiries about <a href="https://breakdowninc.net/">Truck Repair Services</a> , roadside
                     assistance, or our <br />advanced search app for trucking services. We're here to help!</h4>
                 </div>
              </div>
           </div>
           {message.text && (
            <Alert variant={message.variant} className="mt-2 col-md-8 mx-auto py-2">
               {message.text}
            </Alert>
            )}
           <form onSubmit={handleSubmit}>
           <div className="row justify-content-center mt-4 mb-5 pb-md-4 pb-0">
              <div className="col-md-3">
                 <div className="form-group cont_form">
                 <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                  disabled={loading}
                  />
                 </div>
              </div>
              <div className="col-md-3">
                 <div className="form-group cont_form">
                 <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  required
                  disabled={loading}
                  />
                 </div>
              </div>
              <div className="col-md-3">
                 <div className="form-group cont_form">
                 <input
                  type="tel"
                  className="form-control"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone"
                  required
                  disabled={loading}
                  />
                 </div>
              </div>

              <div className="col-md-9">
                 <div className="form-group cont_form">
                 <textarea
                  className="form-control h-auto"
                  rows="3"
                  cols="50"
                  name="formMessage"
                  value={formData.formMessage}
                  onChange={handleChange}
                  placeholder="Write a message"
                  required
                  disabled={loading}
                  />
                 </div>
              </div>
              <div className="col-md-9">
                 <div className="form_btn mt-3">
                 <button type="submit" className="btn" disabled={loading}>
                     {loading ? (
                        <>
                           <Spinner animation="border" size="sm" role="status" className="me-2" />
                           Sending...
                        </>
                     ) : (
                        'Send Your Request'
                     )}
                  </button>
                 </div>
              </div>
           </div>
           </form>

           {/* <hr/> */}

           <div className="row justify-content-center contactIcon_outer">
              <div className="col-md-10 contactIcon">
                 <div className="row">
                   <div className="col-md-4">
                      <div className="contactInfo">
                          <div className="icon_Info">
                          <i className="fa fa-phone" title="phone"></i>
                          </div>
                          <div className="detail_Info">
                            <h3>Phone No.</h3>
                            <h4><a href="tel:+1800-805-7820">800-805-7820</a> - <a href="tel:+17027800780">702-780-0780</a></h4>
                          </div>
                      </div>
                   </div>

                   <div className="col-md-4">
                      <div className="contactInfo">
                          <div className="icon_Info">
                          <i className="fa fa-envelope" title="email"></i>
                          </div>
                          <div className="detail_Info">
                            <h3>Email ID</h3>
                            <h4><a href="mailto:info@breakdowninc.com">info@breakdowninc.com</a></h4>
                          </div>
                      </div>
                   </div>

                   <div className="col-md-4">
                      <div className="contactInfo">
                          <div className="icon_Info">
                          <i className="fa fa-thumbs-up" title="follow"></i>
                          </div>
                          <div className="detail_Info">
                            <h3>Follow Us</h3>
                            <div className="social-Info">
                            <ul>
                            <li><a href="https://www.facebook.com/breakdownincorp" target="_blank"><i className="fab fa-facebook-square" title="facebook"></i></a></li>
                            <li><a href="https://www.instagram.com/breakdownincorp" target="_blank"><i className="fab fa-instagram" title="instagram"></i></a></li>
                            <li><a href="https://twitter.com/Breakdown_inc" target="_blank"><i className="fab fa-x-twitter" title="twitter"></i></a></li>
                            <li><a href="https://www.youtube.com/channel/UCQ-MhvO5t66wKUfvOJeyI7g?view_as=subscriber" target="_blank"><i className="fab fa-youtube" title="youtube"></i></a></li>
                            <li><a href="https://www.linkedin.com/company/breakdown-incorp/" target="_blank"><i className="fab fa-linkedin" title="linkedin"></i></a></li>
                            </ul>
                            </div>
                          </div>
                      </div>
                   </div>
                 </div>
              </div>
           </div>

        </div>
      </section>



      </>
    );
};

export default ContactUs;